import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { SocialProofPopup } from '../components/ui/SocialProofPopup';
import { useMetaPixel } from '../hooks/useMetaPixel';
const PainPointSection = lazy(() => import('../components/PainPointSection').then(m => ({
  default: m.PainPointSection
})));
const ProductRevealSection = lazy(() => import('../components/ProductRevealSection').then(m => ({
  default: m.ProductRevealSection
})));
const ProblemExplanation = lazy(() => import('../components/ProblemExplanation').then(m => ({
  default: m.ProblemExplanation
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ChaptersSection = lazy(() => import('../components/ChaptersSection').then(m => ({
  default: m.ChaptersSection
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const ObjectionsSection = lazy(() => import('../components/ObjectionsSection').then(m => ({
  default: m.ObjectionsSection
})));
const CTASection = lazy(() => import('../components/CTASection').then(m => ({
  default: m.CTASection
})));
const ClosingSection = lazy(() => import('../components/ClosingSection').then(m => ({
  default: m.ClosingSection
})));
export function SalesPage() {
  useMetaPixel();
  return <main className="min-h-screen bg-navy overflow-x-hidden" data-id="element-331">
      <SocialProofPopup data-id="element-332" />
      <HeroSection data-id="element-333" />
      <Suspense fallback={<div className="min-h-[200px]" data-id="element-335" />} data-id="element-334">
        <PainPointSection data-id="element-336" />
        <ProductRevealSection data-id="element-337" />
        <ProblemExplanation data-id="element-338" />
        <BenefitsSection data-id="element-339" />
        <TestimonialsSection data-id="element-340" />
        <ChaptersSection data-id="element-341" />
        <BonusSection data-id="element-342" />
        <ObjectionsSection data-id="element-343" />
        <CTASection data-id="element-344" />
        <ClosingSection data-id="element-345" />
      </Suspense>
    </main>;
}